const styles = (theme) => ({
  container: {
    padding: '16px 22px 8px 22px',
    marginBottom: 4,
    backgroundColor: theme.ModalBGColor
  },  
  title: {
    fontWeight: 500,
    marginBottom: 10,
    color: theme.gridTextColor,
    fontSize: theme.textFontSize,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  optionButton: {
    padding: '6px 14px',
    marginRight: 0,
    minWidth: 40,
    cursor: 'pointer',
    textAlign: 'center',
    backgroundColor: theme.radioLabel,
    fontSize: theme.textFontSize,
    fontWeight: 400,
    color: theme.dispatchPanelLabelValueColor,
    '&:hover': {
      background: theme.disableButtonBG,
      color: theme.TextColor
    },
    '&:active': {
      transform: 'scale(1.02)',
      transition: 'transform 0.1s ease-in-out'
    }
  },
  optionSelected: {
    '&:hover': {
      background: theme.HeaderSelectedText,
      color: theme.white
    },
    backgroundColor: theme.HeaderSelectedText,
    color: theme.ModalBGColor
  },
  separator: {
    borderRight: `1px solid ${theme.AppBGColor}`,
  }
});

export default styles;
